import { render, staticRenderFns } from "./page_navigation_menu.vue.js?vue&type=template&id=3dbc937b&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./page_navigation_menu.vue?vue&type=template&id=3dbc937b&scoped=true"
import script from "./page_navigation_menu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./page_navigation_menu.vue?vue&type=script&lang=js"
export * from "./page_navigation_menu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./page_navigation_menu.vue?vue&type=script&lang=js"
import style0 from "./page_navigation_menu.vue.css?vue&type=style&index=0&id=3dbc937b&prod&scoped=true&lang=css!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./page_navigation_menu.vue?vue&type=style&index=0&id=3dbc937b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbc937b",
  null
  
)

export default component.exports